import { EDataStatus } from "@/frontend/features/Company/model/types/types";

export type TCompanyInfo = {
  id: number;
  parsingStatus: EDataStatus;
  name: string;
  parsingProgress: number;
  parsingMessage?: string;
};

export type TPortfolioCompaniesBulkData = {
  portfolioCompanies: TCompanyInfo[];
};

export enum ESections {
  ERRORS_SECTION = "ERRORS_SECTION",
  ADD_SECTION = "ADD_SECTION"
}

export type { TPipeline } from "@/libs/models/pipelines";

export type TStageShortInfo = {
  id: number;
  name: string;
  order: number;
  isDefault: boolean;
  canBeDeleted: boolean;
  totalPortfolioCompanies: number;
  portfolioCompanies?: any[];
};
